
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 4H3C1.9 4 1 4.9 1 6V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V6C23 4.9 22.1 4 21 4ZM21 18C21 18.55 20.55 19 20 19H12V6H20C20.55 6 21 6.45 21 7V18ZM19.25 9.5H13.75C13.34 9.5 13 9.84 13 10.25C13 10.66 13.34 11 13.75 11H19.25C19.66 11 20 10.66 20 10.25C20 9.84 19.66 9.5 19.25 9.5ZM19.25 12H13.75C13.34 12 13 12.34 13 12.75C13 13.16 13.34 13.5 13.75 13.5H19.25C19.66 13.5 20 13.16 20 12.75C20 12.34 19.66 12 19.25 12ZM19.25 14.5H13.75C13.34 14.5 13 14.84 13 15.25C13 15.66 13.34 16 13.75 16H19.25C19.66 16 20 15.66 20 15.25C20 14.84 19.66 14.5 19.25 14.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-chrome-reader-mode`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconChromeReaderMode

    ```js
    <b-new-b-icon-chrome-reader-mode />
    ```
</docs>


